<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title>
				<span class="headline">{{ $__("Catalogues") }}</span>
				<v-spacer></v-spacer>
				<Link
					as="v-btn"
					:href="
						$route(
							'tenant.catalogues.create',
							$page.props.tenant.id
						)
					"
					color="primary"
				>
					<v-icon left>mdi-plus</v-icon>
					{{ $__("Create") }}
				</Link>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md12>
						<v-simple-table>
							<template v-slot:default>
								<thead>
									<tr>
										<th>{{ $t("Outlet") }}</th>
										<th>{{ $t("Name") }}</th>
										<th>{{ $t("Time") }}</th>
										<th>{{ $t("Mon") }}</th>
										<th>{{ $t("Tue") }}</th>
										<th>{{ $t("Wed") }}</th>
										<th>{{ $t("Thu") }}</th>
										<th>{{ $t("Fri") }}</th>
										<th>{{ $t("Sat") }}</th>
										<th>{{ $t("Sun") }}</th>
										<th>{{ $t("Modules") }}</th>
										<th>Action</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(catalogue, index) in catalogues"
										:key="index"
									>
										<td>
											{{ catalogue.outlet_name }}
										</td>
										<td>
											{{ catalogue.title }}
										</td>
										<td>
											{{ catalogue.start_time }} ~
											{{ catalogue.end_time }}
										</td>
										<td>
											<v-icon
												v-if="catalogue.monday"
												color="success"
												>mdi-check</v-icon
											>
										</td>
										<td>
											<v-icon
												v-if="catalogue.tuesday"
												color="success"
												>mdi-check</v-icon
											>
										</td>
										<td>
											<v-icon
												v-if="catalogue.wednesday"
												color="success"
												>mdi-check</v-icon
											>
										</td>
										<td>
											<v-icon
												v-if="catalogue.thursday"
												color="success"
												>mdi-check</v-icon
											>
										</td>
										<td>
											<v-icon
												v-if="catalogue.friday"
												color="success"
												>mdi-check</v-icon
											>
										</td>
										<td>
											<v-icon
												v-if="catalogue.saturday"
												color="success"
												>mdi-check</v-icon
											>
										</td>
										<td>
											<v-icon
												v-if="catalogue.sunday"
												color="success"
												>mdi-check</v-icon
											>
										</td>
										<td>
											{{ catalogue.modules }}
										</td>
										<td>
											<Link
												as="v-btn"
												:href="
													$route(
														'tenant.catalogues.edit',
														{
															tenant: $page.props
																.tenant.id,
															catalogue:
																catalogue.uuid,
														}
													)
												"
												color="info"
												icon
											>
												<v-icon>mdi-pencil</v-icon>
											</Link>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	props: ["catalogues"],

	components: {
		Link,
	},
};
</script>